import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { Button, Link, Td, Text, Tr, useColorModeValue, VStack } from "@chakra-ui/react";
import moment from "moment";

import { getPropertyAddress } from "../../utils/verifier";
import OwnerPopover from "../ContactPopover/OwnerPopover";

export default function ArchivedPropertiesTableRow({ row }) {
	const { t } = useTranslation();
	const textColor = useColorModeValue("gray.700", "white");

	return (
		<Tr>
			<Td>
				<VStack align="start" spacing="0">
					<Text fontSize="md" color={textColor} fontWeight="bold">
						{getPropertyAddress(row)}
					</Text>
					<Text fontSize="xs" color="gray.500">
						{moment(row.addedDate).format("DD MMM YYYY - HH:mm")}
					</Text>
				</VStack>
			</Td>
			<Td>
				<OwnerPopover contact={row.owner} />
			</Td>
			<Td>
				<Link as={NavLink} to={`/properties/view/${row.id}`}>
					<Button>{t("table.view")}</Button>
				</Link>
			</Td>
		</Tr>
	);
}
